import { htmlSafe } from '@ember/template';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type Intl from 'ember-intl/services/intl';
import type TasApplication from '../../models/tas-application.ts';

interface TuitionAssistanceReimbursementCalculationSignature {
  Args: {
    application: TasApplication;
  };
}

export default class TuitionAssistanceReimbursementCalculationIfApplicableComponent extends Component<TuitionAssistanceReimbursementCalculationSignature> {
  @service declare intl: Intl;

  get isReimbursementByCredit() {
    return (
      this.args.application?.tasProgramInstance?.tasProgramTemplate?.calculateTotalByCredit || false
    );
  }

  get isReimbursementByPercent() {
    return (
      this.args.application?.tasProgramInstance?.tasProgramTemplate?.calculateTotalByPercent ||
      false
    );
  }

  get isReimbursementByGPA() {
    return (
      this.args.application?.tasProgramInstance?.tasProgramTemplate?.calculateTotalByGPA || false
    );
  }

  get showReimbursementCalculation() {
    return (
      this.isReimbursementByCredit || this.isReimbursementByPercent || this.isReimbursementByGPA
    );
  }

  get calculationDescription() {
    if (this.isReimbursementByCredit) {
      return this.intl.t(
        'tuition_assistance.application_details.reimbursement_calculation_by_credit_description'
      );
    }
    if (this.isReimbursementByPercent) {
      return this.intl.t(
        'tuition_assistance.application_details.reimbursement_calculation_by_percent_description',
        {
          percent:
            this.args.application?.tasProgramInstance?.tasProgramTemplate?.reimbursementPercentage,
        }
      );
    }
    if (this.isReimbursementByGPA) {
      return this.intl.t(
        'tuition_assistance.application_details.reimbursement_calculation_by_gpa_description'
      );
    }
    return '';
  }

  <template>
    {{#if this.showReimbursementCalculation}}
      <div class="col-span-full w-full text-gray-500 text-center mt-4">
        <p>{{htmlSafe this.calculationDescription}}</p>
        <p>{{htmlSafe @application.requestedTotalCalculationFormulaNote}}</p>
      </div>
    {{/if}}
  </template>
}
